module.exports = __webpack_public_path__ + "img/quan-item-3.39d0e3ea.png";